<template>
  <div :class="{'news-info': true, 'show-info-active':showNewsInfo}">
    <div class="news-info-content">
      <div class="news-title">
        <h1>{{ newsInfoData.title }}</h1>
        <span class="news-date">时间：{{ newsInfoData.createTime }}</span>
      </div>
      <div class="content-text" v-html="newsInfoData.content">
        
      </div>
    </div>
    <div class="close" @click="closeNewsInfo">
      <img src="@/assets/images/close.png" alt />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    //从vuex里拿到控制详情信息栏目是否展示的值
    showNewsInfo() {
      return this.$store.state.newsFade;
    },
    //从vuex里拿到控制信息栏目的文章
    newsInfoData() {
      return this.$store.state.newsInfoData
    }
  },
  methods: {
    //点击关闭按钮关闭新闻详情模块执行函数
    closeNewsInfo() {
      //提交一个新的mutations进vuex
      this.$store.commit("closeNewsFade");
    }
  }
};
</script>

<style lang='less'>
//引入主色调样式
@import "../../assets/css/mainColor.less";
.news-info {
  position: absolute;
  box-sizing: border-box;
  z-index: 999;
  left: 50%;
  right: 50%;
  height: 100%;
  max-width: 1000px;
  height: 700px;
  position: absolute;
  transition: left 0.5s linear, right 0.5s linear;
  pointer-events: all;
  margin: 0 auto;
  overflow-x: hidden;
  img {
    display: block;
    width: 100%;
    margin: 0 auto;
  }
  //详情主体
  .news-info-content {
    background-color: rgba(23, 47, 75, 0.95);
    border: 1px solid #4FCCFF;
    box-sizing: border-box;
    width: 100%; 
    height: 100%;
    //新闻详情标题设置
    .news-title {
      margin-top: 20px;
      height: 70px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      h1 {
        height: 40px;
        line-height: 40px;
        font-size: 24px;
        color: #4FCCFF;
      }
      span {
        color: #4FCCFF;
      }
    }
    //新闻详情的文章内容设置
    .content-text {
      height: 79%;
      width: 98%;
      line-height: 20px;
      margin: 20px auto 0;
      overflow-y: scroll;
      color: #4FCCFF;
      //滚动条设置
      &::-webkit-scrollbar {
        border-radius: 10px;
        width: 10px;
        background-color: #25373a;
        height: 10px;
      }
      //修改滚动条内部小方块样式
      &::-webkit-scrollbar-thumb {
        background-color: #4FCCFF;
        border-radius: 10px;
      }
    }
  }
  //关闭按钮
  .close {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 30px;
    height: 30px;
    background-color: red;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
    img {
      width: 60%;
      height: 60%;
      margin-top: 5px;
    }
    &:hover {
      box-shadow: 1px 1px 50px red;
    }
  }
}
.show-info-active {
  left: 0;
  right: 0;
}
</style>